<template>
    <main-content>
        <div class="bg-white p-2 shadow-sm">
            <ul class="nav nav-pills" role="tablist">
                <li class="nav-item" role="presentation">
                    <a :class="['nav-link', active_tab === 'wallet-list' ? 'active' : '']"
                       @click="setTab('wallet-list')"
                       href="#"
                       id="wallet-list-tab" role="tab"
                       v-text="$t('wallets.label.wallet_list')">
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a :class="['nav-link', active_tab === 'transaction-list' ? 'active' : '']"
                       @click="setTab('transaction-list')"
                       href="#"
                       id="transaction-list-tab" role="tab"
                       v-text="$t('wallets.label.transaction_list')">
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a :class="['nav-link', active_tab === 'settlement-list' ? 'active' : '']"
                       @click="setTab('settlement-list')"
                       href="#"
                       id="settlement-list-tab" role="tab"
                       v-text="$t('wallets.label.settlement_list')">
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a :class="['nav-link', active_tab === 'wallet-setting' ? 'active' : '']"
                       @click="setTab('wallet-setting')"
                       href="#"
                       id="wallet-setting-tab" role="tab"
                       v-text="$t('wallets.label.wallet_setting')">
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane fade show active"
                     id="wallet-list"
                     role="tabpanel"
                     v-if="active_tab === 'wallet-list'">
                    <wallet-list></wallet-list>
                </div>
                <div class="tab-pane fade show active"
                     id="transaction-list"
                     role="tabpanel"
                     v-if="active_tab === 'transaction-list'">
                    <transaction-list></transaction-list>
                </div>
                <div class="tab-pane fade show active"
                     id="settlement-list"
                     role="tabpanel"
                     v-if="active_tab === 'settlement-list'">
                    <settlement-list></settlement-list>
                </div>
                <div class="tab-pane fade show active"
                     id="wallet-setting"
                     role="tabpanel"
                     v-if="active_tab === 'wallet-setting'">
                    <wallet-setting></wallet-setting>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content.vue";
    import WalletList from "./components/wallet-list.vue";
    import TransactionList from "./components/transaction-list.vue";
    import SettlementList from "./components/settlement-list.vue";
    import WalletSetting from "./components/wallet-setting.vue";

    export default {
        components: {
            mainContent,
            WalletList,
            TransactionList,
            SettlementList,
            WalletSetting,
        },
        data() {
            return {
                active_tab: "wallet-list",
            }
        },
        methods: {
            setTab(selected_tab) {
                this.active_tab = selected_tab;
            },
        },
    }
</script>
